export default __webpack_public_path__ + "static/media/mbway.1a66c241.png";